export default __webpack_public_path__ + "static/covid-cough-dd3d640b5aec0d5f7034a4f9007ac85d.png";